export default "__VITE_ASSET__B$jX2eMA__"